/**
 * Indicator data view settings keys
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/service/WorkbookSettingsConstants.java
 */
export const INDICATOR_SETTINGS_KEYS = {
  TOP_TEXT: 'indicator.text.top',
  BOTTOM_TEXT: 'indicator.text.bottom',
  SHOW_TOP_TEXT: 'indicator.text.top.enabled',
  SHOW_BOTTOM_TEXT: 'indicator.text.bottom.enabled',
  TOP_LINK: 'indicator.link.top',
  BOTTOM_LINK: 'indicator.link.bottom'
};
